import cn from 'classnames';
import { PetType } from 'constants/pet-type';
import {
  AgeSegmentationIds,
  CatAgeSegmentationIds,
  DogAgeSegmentationIds,
} from 'constants/segmentation';
import AnimateDropdown from 'modules/landingpage/components/need-capture/components/content/components/animate-dropdown';
import { useNeedCapture } from 'modules/landingpage/components/need-capture/state';
import { FormattedMessage } from 'react-intl';

interface Props {
  isOpen: boolean;
  selectedOption?: AgeSegmentationIds;
  onSelect: (value: AgeSegmentationIds) => void;
}

/**
 * It renders a list of age. It's used in the need capture component.
 */
const AgeSelectorDesktop: React.FC<Props> = ({
  isOpen,
  selectedOption,
  onSelect,
}) => {
  const { activePetType } = useNeedCapture();
  const ageSegmentationIds =
    activePetType === PetType.Dog
      ? DogAgeSegmentationIds
      : CatAgeSegmentationIds;

  return (
    <AnimateDropdown isOpen={isOpen}>
      {Object.entries(ageSegmentationIds).map(([key, value]) => (
        <button
          key={key}
          className={cn(
            'w-full px-4 py-2 text-left',
            selectedOption === value
              ? 'bg-grey-100 hover:bg-grey-100'
              : 'hover:bg-grey-50'
          )}
          onClick={() => onSelect(value)}
        >
          <FormattedMessage
            id={`common:pet-profile:age-selector:desktop-age-selector:${value}`}
          />
          <span className="text-text-secondary block text-xs leading-[15px] whitespace-nowrap">
            <FormattedMessage
              id={`common:pet-profile:age-selector:desktop-age-selector:description:${value}`}
            />
          </span>
        </button>
      ))}
    </AnimateDropdown>
  );
};

export default AgeSelectorDesktop;
